import { render, staticRenderFns } from "./TicketEdit.vue?vue&type=template&id=4b1a4833"
import script from "./TicketEdit.vue?vue&type=script&lang=js"
export * from "./TicketEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports